document.addEventListener('submit', async function(event) {
  const form = event.target.closest('.df-cart-form, .df-volume-form');

  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const originalText = button ? button.textContent : '';

  if (button) {
    button.disabled = true;
    button.textContent = 'Toevoegen...';
  }

  try {
    const formData = new FormData(form);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Product kon niet worden toegevoegd');
    }

    if (button) {
      button.textContent = 'Toegevoegd';
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    await customElements.whenDefined('cart-icon');

const cartIcons = document.querySelectorAll('cart-icon');

cartIcons.forEach(function(cartIcon) {
  if (typeof cartIcon.renderCartBubble === 'function') {
    cartIcon.renderCartBubble(cart.item_count);
  }
});

document.dispatchEvent(new CustomEvent('cart:refresh', {
  detail: { cart: cart }
}));

  } catch (error) {
    console.error('Dutch Fauna cart error:', error);

    if (button) {
      button.textContent = 'Probeer opnieuw';
    }
  }

  setTimeout(function() {
    if (button) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }, 1400);
});